import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Skeleton from '@material-ui/lab/Skeleton';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import clsx from 'clsx';
import React from 'react';

export type CataloguePageListContentItemRowSkeletonProps =
  StandardDivProps<CataloguePageListContentItemRowSkeletonClassKey>;

export type CataloguePageListContentItemRowSkeletonClassKey =
  | 'root'
  | 'image'
  | 'container'
  | 'box'
  | 'divider'
  | 'imageContainer';

const themeSettings = { name: 'CataloguePageListContentItemRowSkeleton' };
const useStyles = makeStyles(
  (theme) => ({
    root: {
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        height: 'auto',
      },
    },
    image: {
      width: theme.spacing(16),
      height: theme.spacing(12),
    },
    imageContainer: {
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        justifyContent: 'center',
      },
    },
    container: {
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        alignItems: 'flex-end',
      },
    },
    box: {
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(1),
      },
    },
    divider: {
      width: '100%',
    },
  }),
  themeSettings,
);

const CataloguePageListContentItemRowSkeleton: React.FC<CataloguePageListContentItemRowSkeletonProps> = ({
  className,
  classes: pClasses,
}) => {
  const classes = useStyles({ classes: pClasses });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  return isMobile ? (
    <Box
      className={clsx(classes.root, className)}
      display={'flex'}
      height={164}
      padding={2}
      borderBottom={'2px solid rgba(0, 0, 0, 0.12)'}
    >
      <Box padding={1} className={classes.imageContainer}>
        <Skeleton variant='rect' className={classes.image} />
      </Box>
      <Box flexGrow={1}>
        <Box display='flex' height={80} paddingLeft={1} paddingRight={1} className={classes.container}>
          <Divider className={classes.divider} />
          <Skeleton variant='rect' width={136} height={74} className={classes.box} />
        </Box>
        <Divider />
        <Box display='flex' justifyContent='center'>
          <Skeleton height={46} width={'40%'} />
        </Box>
        <Box height={56} flexGrow={1} marginRight={1}>
          <Skeleton variant='text' width={'100%'} height={'100%'} />
        </Box>
      </Box>
    </Box>
  ) : (
    <Box display={'flex'} height={164} padding={2} borderBottom={'2px solid rgba(0, 0, 0, 0.12)'}>
      <Box padding={1}>
        <Skeleton variant='rect' width={128} height={96} />
      </Box>
      <Box flexGrow={1}>
        <Box display='flex' height={80} paddingLeft={1} paddingRight={1}>
          <Box height={56} flexGrow={1} marginRight={1}>
            <Skeleton variant='text' width={'100%'} height={'100%'} />
          </Box>
          <Skeleton variant='rect' width={136} height={74} />
        </Box>
        <Divider />
        <Skeleton height={46} width={'40%'} />
      </Box>
    </Box>
  );
};

CataloguePageListContentItemRowSkeleton.displayName = 'CataloguePageListContentItemRowSkeleton';

export default CataloguePageListContentItemRowSkeleton;
